import { FC } from "react";
import cx from 'classnames';
import styles from './index.module.scss';

type PlacementType = 'top' | 'bottom' | 'left' | 'right';

interface CustomTooltipProps {
  className?: string;
  onClick?: () => void;
  title: React.ReactNode,
  placement?: PlacementType,
  children?: React.ReactNode,
}

enum TooltipPlacement {
  top = 'tooltipTop',
  left = 'tooltipLeft',
  right = 'tooltipRight',
  bottom = 'tooltipBottom',
}

const CustomTooltip: FC<CustomTooltipProps> = ({
  title,
  onClick,
  children,
  className,
  placement = 'top'
}) => {
  
  return (
    <div
      onClick={onClick}
      data-tooltip={title}
      className={cx(`${styles.tooltip} ${styles[TooltipPlacement[placement]]} ${className}`)}
    >
      {children}
    </div>
  )
}

export default CustomTooltip;
